import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'redux';

import AddIcon from '@material-ui/icons/NoteAddTwoTone';
import { CSSTransitionGroup } from 'react-transition-group';

import withMobileDialog from '@material-ui/core/withMobileDialog';
import HeaderWithPeriod from 'components/shared/HeaderWithPeriod';
import FieldItems from 'components/shared/FieldItems/FieldItems';
import { LoadingIndicator } from 'components/ui/LoadingIndicator';

import { getProperties } from 'actions/landlordPropertiesActions';
import { getWorkflows, createOrUpdateWorkflow, deleteWorkflow } from 'actions/insightsActions';

import RenderRule from './RenderRule';
import AddRuleForm from './AddRuleForm';

import { getTranslatedString } from 'helpers/i18n';

const Rules = withMobileDialog()(
  class Rules extends Component {
    constructor(props) {
      super(props);
      this.state = {
        showConfirmationDialog: false,
        isLoading: true,
      };
    }

    componentDidMount = async () => {
      this.props.getProperties({ for_multiselect: true });
      await this.props.getWorkflows();
      this.setState({ isLoading: false });
    };

    createOrUpdateRule = async formData => {
      await this.props.createOrUpdateWorkflow(formData);
      this.props.getWorkflows();
    };

    deleteRule = async workflowDetails => {
      this.setState({ showConfirmationDialog: true });
      await this.props.deleteWorkflow(workflowDetails.id);
      this.props.getWorkflows();
    };

    render() {
      return (
        <div className="body" role="main">
          <div className="centers">
            <HeaderWithPeriod headerText="Workflows" />
            <CSSTransitionGroup
              transitionName="fade_out_buttons"
              transitionEnterTimeout={200}
              transitionLeaveTimeout={200}
            >
              <div
                className="row"
                style={{ height: '100%', textAlign: 'center', padding: '5vh 0 0' }}
              >
                <LoadingIndicator
                  shouldRender={this.state.isLoading}
                  text={getTranslatedString('landlordPortal.rulesIndex.loadingText')}
                />
                {!this.state.isLoading && this._renderNoRulesPresent()}
                {!this.state.isLoading && this._renderAddRules()}
              </div>
            </CSSTransitionGroup>
          </div>
        </div>
      );
    }

    _renderNoRulesPresent = () => {
      if (this.props.workflows.length > 0) return;

      return (
        <React.Fragment>
          <AddIcon style={{ color: '#eaeaea', height: '20vh', width: '20vh' }} />
          <div className="row" style={{ textAlign: 'center', marginTop: '8px' }}>
            <h4
              style={{
                width: '300px',
                fontFamily: 'Circular',
                textAlign: 'center',
                margin: '0 auto 20px',
              }}
            >
              Hm - there aren&#39;t any workflows yet.
            </h4>
          </div>
        </React.Fragment>
      );
    };

    _renderAddRules = () => (
      <div className="row" style={{ paddingBottom: '70px' }}>
        <FieldItems
          name="workflows"
          formName={this.props.form}
          renderSavedItems={RenderRule}
          renderForm={AddRuleForm}
          dialogHeader="Add Workflow"
          buttonVerbiageOverride="Add Workflow"
          formProps={{ properties: this.props.properties }}
          initialValues={{ properties: [] }}
          onSave={this.createOrUpdateRule}
          onDelete={this.deleteRule}
        />
      </div>
    );
  }
);

export default compose(
  connect(
    store => ({
      properties: store.landlordProperties.properties,
      initialValues: { workflows: store.insights.workflows },
      workflows: store.insights.workflows,
    }),
    {
      getProperties,
      getWorkflows,
      createOrUpdateWorkflow,
      deleteWorkflow,
    }
  ),
  reduxForm({
    form: 'add_rules_form',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    enableReinitialize: true,
  })
)(Rules);
